// Bundled with esbuild via jsbundling-rails.
// jQuery must be exposed globally before any plugin or step module loads;
// lib/jquery also registers the Select2 v4 factory against our jQuery instance.
import "./lib/jquery";

// Bootstrap pulls @popperjs/core itself; the legacy popper.js (1.x) is dropped.
import "bootstrap";
import toastr from "toastr";
import "@fortawesome/fontawesome-free/js/all";

// Stimulus controllers (bundled here by esbuild; see app/javascript/controllers).
import "./controllers";

// rails-ujs handles data-method (DELETE/POST links) and data-confirm dialogs.
import Rails from "@rails/ujs";
Rails.start();

import "./channels";

// Legal profile pipeline
import "./application/users/profiles/legal/investor_identification_step.js";
import "./application/users/profiles/legal/professional_client_classification_step.js";
import "./application/users/profiles/legal/retail_client_classification_step.js";
import "./application/users/profiles/legal/financial_information_step.js";
import "./application/users/profiles/legal/knowledge_step.js";
import "./application/users/profiles/legal/expertise_step.js";
import "./application/users/profiles/legal/tax_details_step.js";
import "./application/users/profiles/legal/ownership_step.js";
import "./application/users/profiles/legal/origin_of_funds_step.js";
import "./application/users/profiles/legal/us_supplement_step.js";
import "./application/users/profiles/legal/documents_step.js";

// Natural profile pipeline
import "./application/users/profiles/natural/investor_identification_step.js";
import "./application/users/profiles/natural/classification_step.js";
import "./application/users/profiles/natural/financial_information_step.js";
import "./application/users/profiles/natural/knowledge_step.js";
import "./application/users/profiles/natural/expertise_step.js";
import "./application/users/profiles/natural/tax_details_step.js";
import "./application/users/profiles/natural/origin_of_funds_step.js";
import "./application/users/profiles/natural/us_supplement_step.js";
import "./application/users/profiles/natural/documents_step.js";

// Common user profile pipelines steps
import "./application/users/profiles/contacts_step.js";
import "./application/users/profiles/erisa_benefit_plan_step.js";
import "./application/users/profiles/benefit_plan_step.js";
import "./application/users/profiles/sustainability_preferences_step.js";
import "./application/users/profiles/bad_actor_rules_step.js";
import "./application/users/profiles/representations_and_warranties_step.js";

// Subscription pipeline
import "./application/users/subscriptions/details_step.js";
import "./application/users/subscriptions/agreements_step.js";

// Completed subscriptions
import "./application/users/completed_subscriptions/edit.js";

// Distributors account info page and invitation form
import "./application/distributors.js";

// Distributors investor creation form
import "./application/distributors/users.js";

toastr.options.toastClass = "toastr";

$(document).ready(() => {
  if ($(".flash.info")[0]) {
    toastr["info"]($(".flash.info").html());
  }
  if ($(".flash.notice")[0]) {
    toastr["info"]($(".flash.notice").html());
  }
  if ($(".flash.success")[0]) {
    toastr["success"]($(".flash.success").html());
  }
  if ($(".flash.error")[0]) {
    toastr["error"]($(".flash.error").html());
  }
  if ($(".flash.alert")[0]) {
    toastr["error"]($(".flash.alert").html());
  }

  $("select.custom-select").select2();

  $("body").on("change", ".custom-file-input", function() {
    if ($(this)[0].files[0] !== undefined) {
      $(this)
        .siblings(".custom-file-label")
        .html($(this)[0].files[0].name);
    }
  });
});
